// removed by extract-text-webpack-plugin
module.exports = {"podCol":"CwPodCol-podCol","podColWithoutSectionHeader":"CwPodCol-podColWithoutSectionHeader","podColWithSectionHeader":"CwPodCol-podColWithSectionHeader","sectionHeader":"CwPodCol-sectionHeader","ghostSectionHeader":"CwPodCol-ghostSectionHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpod/CwPodCol.scss
// module id = 378
// module chunks = 0